const makeParamRoute =
  (route: string) =>
  (params?: string | number | null, isChildRoute?: boolean): string => {
    const routePrefix = isChildRoute ? '' : `${route}/`;
    return params ? `${routePrefix}${params}` : route;
  };

export const ROUTES = {
  base: '/',
  login: '/login',
  feed: '/feed',
  markets: '/markets',
  deals: '/deals',
  events: '/events',
  customPage: makeParamRoute('/page'),
  search: '/search',
  globalFeed: '/feed/global',
  myContent: '/my-content',
  article: makeParamRoute('/articles'),
  company: makeParamRoute('/companies'),
  municipal: makeParamRoute('/municipals'),
  notFound: '/404',
  sectors: makeParamRoute('/feed/global/sectors'),
  specialSituations: '/special-situations',
  dashboards: makeParamRoute('/dashboards'),
  redirect: '/redirect',
};

export const COMPANY_ROUTES = {
  recentlyPublished: 'recently-published',
  deals: 'deals',
  loans: makeParamRoute('deals/loans'),
  bonds: makeParamRoute('deals/bonds'),
  events: 'events',
  documents: 'documents',
  bondsDocuments: 'bonds',
  loansDocuments: 'loans',
  risk: 'risk',
  dockets: 'dockets',
  financials: 'financials',
};

export const MY_CONTENT_ROUTES = {
  articles: makeParamRoute('articles'),
  watchlists: makeParamRoute('watchlists'),
  searches: 'searches',
  covenants: 'covenants',
  managePreferences: 'preferences',
};

export const EXTERNAL_ROUTES = {
  companyList: '/company-list',
  onboarding: '/user/onboarding',
  analysts: makeParamRoute('/analysts'),
};

export const FEED_BATCH_SIZE = 50;
export const HIDE_PAGINATION_VALUE = 10;
export const DEFAULT_DEBOUNCE_RATE = 500;

export const NO_DATA = '--';

export type DateType = Date | null;

export const EM_DASH = '—';

export const GENERIC_ERROR_TEXT = 'Oops! Something went wrong. Please try again';
